export function toIso3Code(iso2: string) {
  switch (iso2) {
    case 'AD':
      return 'AND';
    case 'AE':
      return 'ARE';
    case 'AF':
      return 'AFG';
    case 'AG':
      return 'ATG';
    case 'AI':
      return 'AIA';
    case 'AL':
      return 'ALB';
    case 'AM':
      return 'ARM';
    case 'AN':
      return 'ANT';
    case 'AO':
      return 'AGO';
    case 'AR':
      return 'ARG';
    case 'AS':
      return 'ASM';
    case 'AT':
      return 'AUT';
    case 'AU':
      return 'AUS';
    case 'AW':
      return 'ABW';
    case 'AZ':
      return 'AZE';
    case 'BA':
      return 'BIH';
    case 'BB':
      return 'BRB';
    case 'BD':
      return 'BGD';
    case 'BE':
      return 'BEL';
    case 'BF':
      return 'BFA';
    case 'BG':
      return 'BGR';
    case 'BH':
      return 'BHR';
    case 'BI':
      return 'BDI';
    case 'BJ':
      return 'BEN';
    case 'BL':
      return 'BES';
    case 'BM':
      return 'BMU';
    case 'BN':
      return 'BRN';
    case 'BO':
      return 'BOL';
    case 'BR':
      return 'BRA';
    case 'BS':
      return 'BHS';
    case 'BT':
      return 'BTN';
    case 'BW':
      return 'BWA';
    case 'BY':
      return 'BLR';
    case 'BZ':
      return 'BLZ';
    case 'CA':
      return 'CAN';
    case 'CD':
      return 'COD';
    case 'CF':
      return 'CAF';
    case 'CG':
      return 'COG';
    case 'CH':
      return 'CHE';
    case 'CI':
      return 'CIV';
    case 'CK':
      return 'COK';
    case 'CL':
      return 'CHL';
    case 'CM':
      return 'CMR';
    case 'CN':
      return 'CHN';
    case 'CO':
      return 'COL';
    case 'CR':
      return 'CRI';
    case 'CU':
      return 'CUB';
    case 'CV':
      return 'CPV';
    case 'CW':
      return 'CUW';
    case 'CY':
      return 'CYP';
    case 'CZ':
      return 'CZE';
    case 'DE':
      return 'DEU';
    case 'DJ':
      return 'DJI';
    case 'DK':
      return 'DNK';
    case 'DM':
      return 'DMA';
    case 'DO':
      return 'DOM';
    case 'DZ':
      return 'DZA';
    case 'EC':
      return 'ECU';
    case 'EE':
      return 'EST';
    case 'EG':
      return 'EGY';
    case 'ER':
      return 'ERI';
    case 'ES':
      return 'ESP';
    case 'ET':
      return 'ETH';
    case 'EU':
      return 'BES';
    case 'FI':
      return 'FIN';
    case 'FJ':
      return 'FJI';
    case 'FK':
      return 'FLK';
    case 'FM':
      return 'FSM';
    case 'FO':
      return 'FRO';
    case 'FR':
      return 'FRA';
    case 'GA':
      return 'GAB';
    case 'GB':
      return 'GBR';
    case 'GD':
      return 'GRD';
    case 'GE':
      return 'GEO';
    case 'GF':
      return 'GUF';
    case 'GG':
      return 'GGY';
    case 'GH':
      return 'GHA';
    case 'GI':
      return 'GIB';
    case 'GL':
      return 'GRL';
    case 'GM':
      return 'GMB';
    case 'GN':
      return 'GIN';
    case 'GP':
      return 'GLP';
    case 'GQ':
      return 'GNQ';
    case 'GR':
      return 'GRC';
    case 'GT':
      return 'GTM';
    case 'GU':
      return 'GUM';
    case 'GW':
      return 'GNB';
    case 'GY':
      return 'GUY';
    case 'HK':
      return 'HKG';
    case 'HN':
      return 'HND';
    case 'HR':
      return 'HRV';
    case 'HT':
      return 'HTI';
    case 'HU':
      return 'HUN';
    case 'ID':
      return 'IDN';
    case 'IE':
      return 'IRL';
    case 'IL':
      return 'ISR';
    case 'IN':
      return 'IND';
    case 'IQ':
      return 'IRQ';
    case 'IR':
      return 'IRN';
    case 'IS':
      return 'ISL';
    case 'IT':
      return 'ITA';
    case 'JE':
      return 'JEY';
    case 'JM':
      return 'JAM';
    case 'JO':
      return 'JOR';
    case 'JP':
      return 'JPN';
    case 'KE':
      return 'KEN';
    case 'KG':
      return 'KGZ';
    case 'KH':
      return 'KHM';
    case 'KI':
      return 'KIR';
    case 'KM':
      return 'COM';
    case 'KN':
      return 'KNA';
    case 'KP':
      return 'PRK';
    case 'KR':
      return 'KOR';
    case 'KW':
      return 'KWT';
    case 'KY':
      return 'CYM';
    case 'KZ':
      return 'KAZ';
    case 'LA':
      return 'LAO';
    case 'LB':
      return 'LBN';
    case 'LC':
      return 'LCA';
    case 'LI':
      return 'LIE';
    case 'LK':
      return 'LKA';
    case 'LR':
      return 'LBR';
    case 'LS':
      return 'LSO';
    case 'LT':
      return 'LTU';
    case 'LU':
      return 'LUX';
    case 'LV':
      return 'LVA';
    case 'LY':
      return 'LBY';
    case 'MA':
      return 'MAR';
    case 'MC':
      return 'MCO';
    case 'MD':
      return 'MDA';
    case 'ME':
      return 'MNE';
    case 'MF':
      return 'MAF';
    case 'MG':
      return 'MDG';
    case 'MH':
      return 'MHL';
    case 'MK':
      return 'MKD';
    case 'ML':
      return 'MLI';
    case 'MM':
      return 'MMR';
    case 'MN':
      return 'MNG';
    case 'MO':
      return 'MAC';
    case 'MP':
      return 'MNP';
    case 'MQ':
      return 'MTQ';
    case 'MR':
      return 'MRT';
    case 'MS':
      return 'MSR';
    case 'MT':
      return 'MLT';
    case 'MU':
      return 'MUS';
    case 'MV':
      return 'MDV';
    case 'MW':
      return 'MWI';
    case 'MX':
      return 'MEX';
    case 'MY':
      return 'MYS';
    case 'MZ':
      return 'MOZ';
    case 'NA':
      return 'NAM';
    case 'NC':
      return 'NCL';
    case 'NE':
      return 'NER';
    case 'NG':
      return 'NGA';
    case 'NI':
      return 'NIC';
    case 'NL':
      return 'NLD';
    case 'NO':
      return 'NOR';
    case 'NP':
      return 'NPL';
    case 'NR':
      return 'NRU';
    case 'NU':
      return 'NIU';
    case 'NZ':
      return 'NZL';
    case 'OM':
      return 'OMN';
    case 'PA':
      return 'PAN';
    case 'PE':
      return 'PER';
    case 'PF':
      return 'PYF';
    case 'PG':
      return 'PNG';
    case 'PH':
      return 'PHL';
    case 'PK':
      return 'PAK';
    case 'PL':
      return 'POL';
    case 'PR':
      return 'PRI';
    case 'PS':
      return 'PSE';
    case 'PT':
      return 'PRT';
    case 'PW':
      return 'PLW';
    case 'PY':
      return 'PRY';
    case 'QA':
      return 'QAT';
    case 'RE':
      return 'REU';
    case 'RO':
      return 'ROU';
    case 'RS':
      return 'SRB';
    case 'RU':
      return 'RUS';
    case 'RW':
      return 'RWA';
    case 'SA':
      return 'SAU';
    case 'SB':
      return 'SLB';
    case 'SC':
      return 'SYC';
    case 'SD':
      return 'SDN';
    case 'SE':
      return 'SWE';
    case 'SG':
      return 'SGP';
    case 'SI':
      return 'SVN';
    case 'SK':
      return 'SVK';
    case 'SL':
      return 'SLE';
    case 'SM':
      return 'SMR';
    case 'SN':
      return 'SEN';
    case 'SO':
      return 'SOM';
    case 'SR':
      return 'SUR';
    case 'ST':
      return 'STP';
    case 'SV':
      return 'SLV';
    case 'SY':
      return 'SYR';
    case 'SZ':
      return 'SWZ';
    case 'TC':
      return 'TCA';
    case 'TD':
      return 'TCD';
    case 'TG':
      return 'TGO';
    case 'TH':
      return 'THA';
    case 'TJ':
      return 'TJK';
    case 'TL':
      return 'TLS';
    case 'TM':
      return 'TKM';
    case 'TN':
      return 'TUN';
    case 'TO':
      return 'TON';
    case 'TR':
      return 'TUR';
    case 'TT':
      return 'TTO';
    case 'TV':
      return 'TUV';
    case 'TW':
      return 'TWN';
    case 'TZ':
      return 'TZA';
    case 'UA':
      return 'UKR';
    case 'UG':
      return 'UGA';
    case 'US':
      return 'USA';
    case 'UY':
      return 'URY';
    case 'UZ':
      return 'UZB';
    case 'VC':
      return 'VCT';
    case 'VE':
      return 'VEN';
    case 'VG':
      return 'VGB';
    case 'VI':
      return 'VIR';
    case 'VN':
      return 'VNM';
    case 'VU':
      return 'VUT';
    case 'WF':
      return 'WLF';
    case 'WS':
      return 'WSM';
    case 'YE':
      return 'YEM';
    case 'YT':
      return 'MYT';
    case 'ZA':
      return 'ZAF';
    case 'ZM':
      return 'ZMB';
    case 'ZW':
      return 'ZWE';
  }
}

export function toIso2Code(iso3: string) {
  switch (iso3) {
    case 'ABW':
      return 'AW';
    case 'AFG':
      return 'AF';
    case 'AGO':
      return 'AO';
    case 'AIA':
      return 'AI';
    case 'ALB':
      return 'AL';
    case 'AND':
      return 'AD';
    case 'ANT':
      return 'AN';
    case 'ARE':
      return 'AE';
    case 'ARG':
      return 'AR';
    case 'ARM':
      return 'AM';
    case 'ASM':
      return 'AS';
    case 'ATG':
      return 'AG';
    case 'AUS':
      return 'AU';
    case 'AUT':
      return 'AT';
    case 'AZE':
      return 'AZ';
    case 'BDI':
      return 'BI';
    case 'BEL':
      return 'BE';
    case 'BEN':
      return 'BJ';
    case 'BES':
      return 'BL';
    case 'BFA':
      return 'BF';
    case 'BGD':
      return 'BD';
    case 'BGR':
      return 'BG';
    case 'BHR':
      return 'BH';
    case 'BHS':
      return 'BS';
    case 'BIH':
      return 'BA';
    case 'BLR':
      return 'BY';
    case 'BLZ':
      return 'BZ';
    case 'BMU':
      return 'BM';
    case 'BOL':
      return 'BO';
    case 'BRA':
      return 'BR';
    case 'BRB':
      return 'BB';
    case 'BRN':
      return 'BN';
    case 'BTN':
      return 'BT';
    case 'BWA':
      return 'BW';
    case 'CAF':
      return 'CF';
    case 'CAN':
      return 'CA';
    case 'CHE':
      return 'CH';
    case 'CHL':
      return 'CL';
    case 'CHN':
      return 'CN';
    case 'CIV':
      return 'CI';
    case 'CMR':
      return 'CM';
    case 'COD':
      return 'CD';
    case 'COG':
      return 'CG';
    case 'COK':
      return 'CK';
    case 'COL':
      return 'CO';
    case 'COM':
      return 'KM';
    case 'CPV':
      return 'CV';
    case 'CRI':
      return 'CR';
    case 'CUB':
      return 'CU';
    case 'CUW':
      return 'CW';
    case 'CYM':
      return 'KY';
    case 'CYP':
      return 'CY';
    case 'CZE':
      return 'CZ';
    case 'DEU':
      return 'DE';
    case 'DJI':
      return 'DJ';
    case 'DMA':
      return 'DM';
    case 'DNK':
      return 'DK';
    case 'DOM':
      return 'DO';
    case 'DZA':
      return 'DZ';
    case 'ECU':
      return 'EC';
    case 'EGY':
      return 'EG';
    case 'ERI':
      return 'ER';
    case 'ESP':
      return 'ES';
    case 'EST':
      return 'EE';
    case 'ETH':
      return 'ET';
    case 'FIN':
      return 'FI';
    case 'FJI':
      return 'FJ';
    case 'FLK':
      return 'FK';
    case 'FRA':
      return 'FR';
    case 'FRO':
      return 'FO';
    case 'FSM':
      return 'FM';
    case 'GAB':
      return 'GA';
    case 'GBR':
      return 'GB';
    case 'GEO':
      return 'GE';
    case 'GGY':
      return 'GG';
    case 'GHA':
      return 'GH';
    case 'GIB':
      return 'GI';
    case 'GIN':
      return 'GN';
    case 'GLP':
      return 'GP';
    case 'GMB':
      return 'GM';
    case 'GNB':
      return 'GW';
    case 'GNQ':
      return 'GQ';
    case 'GRC':
      return 'GR';
    case 'GRD':
      return 'GD';
    case 'GRL':
      return 'GL';
    case 'GTM':
      return 'GT';
    case 'GUF':
      return 'GF';
    case 'GUM':
      return 'GU';
    case 'GUY':
      return 'GY';
    case 'HKG':
      return 'HK';
    case 'HND':
      return 'HN';
    case 'HRV':
      return 'HR';
    case 'HTI':
      return 'HT';
    case 'HUN':
      return 'HU';
    case 'IDN':
      return 'ID';
    case 'IND':
      return 'IN';
    case 'IRL':
      return 'IE';
    case 'IRN':
      return 'IR';
    case 'IRQ':
      return 'IQ';
    case 'ISL':
      return 'IS';
    case 'ISR':
      return 'IL';
    case 'ITA':
      return 'IT';
    case 'JAM':
      return 'JM';
    case 'JEY':
      return 'JE';
    case 'JOR':
      return 'JO';
    case 'JPN':
      return 'JP';
    case 'KAZ':
      return 'KZ';
    case 'KEN':
      return 'KE';
    case 'KGZ':
      return 'KG';
    case 'KHM':
      return 'KH';
    case 'KIR':
      return 'KI';
    case 'KNA':
      return 'KN';
    case 'KOR':
      return 'KR';
    case 'KWT':
      return 'KW';
    case 'LAO':
      return 'LA';
    case 'LBN':
      return 'LB';
    case 'LBR':
      return 'LR';
    case 'LBY':
      return 'LY';
    case 'LCA':
      return 'LC';
    case 'LIE':
      return 'LI';
    case 'LKA':
      return 'LK';
    case 'LSO':
      return 'LS';
    case 'LTU':
      return 'LT';
    case 'LUX':
      return 'LU';
    case 'LVA':
      return 'LV';
    case 'MAC':
      return 'MO';
    case 'MAF':
      return 'MF';
    case 'MAR':
      return 'MA';
    case 'MCO':
      return 'MC';
    case 'MDA':
      return 'MD';
    case 'MDG':
      return 'MG';
    case 'MDV':
      return 'MV';
    case 'MEX':
      return 'MX';
    case 'MHL':
      return 'MH';
    case 'MKD':
      return 'MK';
    case 'MLI':
      return 'ML';
    case 'MLT':
      return 'MT';
    case 'MMR':
      return 'MM';
    case 'MNE':
      return 'ME';
    case 'MNG':
      return 'MN';
    case 'MNP':
      return 'MP';
    case 'MOZ':
      return 'MZ';
    case 'MRT':
      return 'MR';
    case 'MSR':
      return 'MS';
    case 'MTQ':
      return 'MQ';
    case 'MUS':
      return 'MU';
    case 'MWI':
      return 'MW';
    case 'MYS':
      return 'MY';
    case 'MYT':
      return 'YT';
    case 'NAM':
      return 'NA';
    case 'NCL':
      return 'NC';
    case 'NER':
      return 'NE';
    case 'NGA':
      return 'NG';
    case 'NIC':
      return 'NI';
    case 'NIU':
      return 'NU';
    case 'NLD':
      return 'NL';
    case 'NOR':
      return 'NO';
    case 'NPL':
      return 'NP';
    case 'NRU':
      return 'NR';
    case 'NZL':
      return 'NZ';
    case 'OMN':
      return 'OM';
    case 'PAK':
      return 'PK';
    case 'PAN':
      return 'PA';
    case 'PER':
      return 'PE';
    case 'PHL':
      return 'PH';
    case 'PLW':
      return 'PW';
    case 'PNG':
      return 'PG';
    case 'POL':
      return 'PL';
    case 'PRI':
      return 'PR';
    case 'PRK':
      return 'KP';
    case 'PRT':
      return 'PT';
    case 'PRY':
      return 'PY';
    case 'PSE':
      return 'PS';
    case 'PYF':
      return 'PF';
    case 'QAT':
      return 'QA';
    case 'REU':
      return 'RE';
    case 'ROU':
      return 'RO';
    case 'RUS':
      return 'RU';
    case 'RWA':
      return 'RW';
    case 'SAU':
      return 'SA';
    case 'SDN':
      return 'SD';
    case 'SEN':
      return 'SN';
    case 'SGP':
      return 'SG';
    case 'SLB':
      return 'SB';
    case 'SLE':
      return 'SL';
    case 'SLV':
      return 'SV';
    case 'SMR':
      return 'SM';
    case 'SOM':
      return 'SO';
    case 'SRB':
      return 'RS';
    case 'STP':
      return 'ST';
    case 'SUR':
      return 'SR';
    case 'SVK':
      return 'SK';
    case 'SVN':
      return 'SI';
    case 'SWE':
      return 'SE';
    case 'SWZ':
      return 'SZ';
    case 'SYC':
      return 'SC';
    case 'SYR':
      return 'SY';
    case 'TCA':
      return 'TC';
    case 'TCD':
      return 'TD';
    case 'TGO':
      return 'TG';
    case 'THA':
      return 'TH';
    case 'TJK':
      return 'TJ';
    case 'TKM':
      return 'TM';
    case 'TLS':
      return 'TL';
    case 'TON':
      return 'TO';
    case 'TTO':
      return 'TT';
    case 'TUN':
      return 'TN';
    case 'TUR':
      return 'TR';
    case 'TUV':
      return 'TV';
    case 'TWN':
      return 'TW';
    case 'TZA':
      return 'TZ';
    case 'UGA':
      return 'UG';
    case 'UKR':
      return 'UA';
    case 'URY':
      return 'UY';
    case 'USA':
      return 'US';
    case 'UZB':
      return 'UZ';
    case 'VCT':
      return 'VC';
    case 'VEN':
      return 'VE';
    case 'VGB':
      return 'VG';
    case 'VIR':
      return 'VI';
    case 'VNM':
      return 'VN';
    case 'VUT':
      return 'VU';
    case 'WLF':
      return 'WF';
    case 'WSM':
      return 'WS';
    case 'YEM':
      return 'YE';
    case 'ZAF':
      return 'ZA';
    case 'ZMB':
      return 'ZM';
    case 'ZWE':
      return 'ZW';
    default:
      return iso3;
  }
}
